
class CapSkipEmailGeneration {
  constructor() {}
  checkPermission() {
    return false
  }
}

function key() {
  return 'skip_email_generation'
}

function create() {
  return new CapSkipEmailGeneration()
}

export default {
  key,
  create,
}
